// DEPRECATED: colspan max doesn't work anymore!
export default function LoadingRow() {
	return <tr>
		<td colSpan={100} style={{ textAlign: 'center' }}>
			<span className="fa fa-spinner fa-pulse" style={{ fontSize: '18px' }}></span>
		</td>
	</tr>;
}